"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminAnnouncementResponseDto = instanceOfAdminAnnouncementResponseDto;
exports.AdminAnnouncementResponseDtoFromJSON = AdminAnnouncementResponseDtoFromJSON;
exports.AdminAnnouncementResponseDtoFromJSONTyped = AdminAnnouncementResponseDtoFromJSONTyped;
exports.AdminAnnouncementResponseDtoToJSON = AdminAnnouncementResponseDtoToJSON;
exports.AdminAnnouncementResponseDtoToJSONTyped = AdminAnnouncementResponseDtoToJSONTyped;
/**
 * Check if a given object implements the AdminAnnouncementResponseDto interface.
 */
function instanceOfAdminAnnouncementResponseDto(value) {
    if (!('broadcastId' in value) || value['broadcastId'] === undefined)
        return false;
    if (!('topic' in value) || value['topic'] === undefined)
        return false;
    return true;
}
function AdminAnnouncementResponseDtoFromJSON(json) {
    return AdminAnnouncementResponseDtoFromJSONTyped(json, false);
}
function AdminAnnouncementResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'broadcastId': json['broadcastId'],
        'topic': json['topic'],
    };
}
function AdminAnnouncementResponseDtoToJSON(json) {
    return AdminAnnouncementResponseDtoToJSONTyped(json, false);
}
function AdminAnnouncementResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'broadcastId': value['broadcastId'],
        'topic': value['topic'],
    };
}
